import columns from '../../../../react-table/helpers/columns';
import { sumTotal, formattedFloatSumTotal } from '../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    TextColumn,
    DateTimeColumn,
    NonZeroNumberColumn,
    NonZeroFloatColumn,
    ExternalConsignmentLinkColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new ExternalConsignmentLinkColumn(new TextColumn('Consignment ID', 'consignmentId')),
        new TextColumn('Origin', 'origin'),
        new TextColumn('Destination', 'destination'),
        new TextColumn('Mail category', 'mailCategory'),
        new TextColumn('Mail subclass', 'mailSubclass'),
        new DateTimeColumn('Completion date', 'completionDate'),
        new DateTimeColumn('Planned departure', 'plannedDepartureDate'),
        new DateTimeColumn('Planned arrival', 'plannedArrivalDate'),
        new TextColumn('Conveyance reference', 'conveyanceReference').withTotalHeader('Total'),
        new NonZeroNumberColumn('Receptacles', 'receptacles').withTotalHeader(sumTotal),
        new NonZeroFloatColumn('Weight', 'weight').withTotalHeader(formattedFloatSumTotal),
      ],
    },
  ];
};
